export default __webpack_public_path__ + "static/media/Wrist-straps of the Death Master.1c8dc791.jpg";